const values = [
  "bundle_cart_coin",
  "icon_card_blue",
  "icon_card_pink",
  "shop_gem_lv1",
  "shop_gem_lv1_hightlight",
  "shop_gem_lv2",
  "shop_gem_lv2_hightlight",
  "shop_gem_lv3",
  "shop_gem_lv3_hightlight",
  "shop_gem_lv4",
  "shop_gem_lv4_hightlight",
  "shop_gem_lv5",
  "shop_gem_lv5_hightlight",
];
export default values;
